import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=17361328&"
import script from "./InstagramFeed.vue?vue&type=script&lang=js&"
export * from "./InstagramFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('17361328', component.options)
    } else {
      api.reload('17361328', component.options)
    }
    module.hot.accept("./InstagramFeed.vue?vue&type=template&id=17361328&", function () {
      api.rerender('17361328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/InstagramFeed.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/InstagramFeed.vue
// module id = 125
// module chunks = 7